import Amplify, { API } from 'aws-amplify'

Amplify.configure({
  Auth: {
    // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
    identityPoolId: process.env.REACT_APP_IDENTITYPOOLID,

    // REQUIRED - Amazon Cognito Region
    region: process.env.REACT_APP_REGION,

    // OPTIONAL - Amazon Cognito Federated Identity Pool Region
    // Required only if it's different from Amazon Cognito Region
    // identityPoolRegion: 'us-east-1',

    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: process.env.REACT_APP_USERPOOLID,

    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: process.env.REACT_APP_USERPOOLWEBCLIENTID,

    // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
    mandatorySignIn: true,

    // OPTIONAL - Configuration for cookie storage
    // Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol
    cookieStorage: {
    // REQUIRED - Cookie domain (only required if cookieStorage is provided)
        domain: process.env.REACT_APP_ENV === 'prod' ? '.shopmate.co.uk' : 'localhost',
    // OPTIONAL - Cookie path
        path: '/',
    // OPTIONAL - Cookie expiration in days
        expires: 365,
    // OPTIONAL - Cookie secure flag
    // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
        secure: true
    },

    // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
    // authenticationFlowType: 'USER_PASSWORD_AUTH'
  },
  API: {
    endpoints: [
      {
        name: 'Portal API',
        endpoint: process.env.REACT_APP_PORTALAPI,
        region: process.env.REACT_APP_REGION
      }
    ]
  }
})

const dashboardResponse = async () => {
  const apiName = 'Portal API'
  const path = '/org'
  const myInit = { // OPTIONAL
    headers: {}, // OPTIONAL
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {} // OPTIONAL
  }
  const res = await API.post(apiName, path, myInit)

  return (res.data)
}

const registerSitesResponse = async (data) => {
  const apiName = 'Portal API'
  const path = '/link-org'
  const myInit = {
    headers: {},
    response: true,
    body: data
  }

  const res = await API.post(apiName, path, myInit)

  return (res.data)
}

export {
  dashboardResponse,
  registerSitesResponse
}
